import { Directive, ViewContainerRef } from '@angular/core';

@Directive({
    selector: '[appRibbonDialogContent]'
})
export class RibbonDialogContentDirective {
    constructor(public viewContainerRef: ViewContainerRef) {}
}
